/**
 * Hebrew Text Utilities
 * Common functions for formatting and rendering Hebrew text
 */
import React from 'react';
import { segmentWordByShva } from './shvaDetector';

/**
 * Replace hyphens (-), Hebrew maqaf (־), or underscores (_) with a whitespace
 * - is U+002D, _ is U+005F, ־ is U+05BE
 */
export const formatHebrewText = (text: string): string => {
  return text.replace(/[-_\u05BE]/g, ' ');
};

/**
 * Render Hebrew text with Shva Na highlighted (bolder/larger)
 * Shva Na (שְׁוָא נָע) is pronounced, unlike Shva Nach which is silent
 */
export const renderHebrewWithShvaNa = (text: string): React.ReactNode => {
  const formattedText = formatHebrewText(text);
  const words = formattedText.split(/\s+/);

  return words.map((word, wordIdx) => {
    const segments = segmentWordByShva(word);

    return (
      <React.Fragment key={wordIdx}>
        {segments.map((segment, segIdx) => {
          if (segment.isShvaNa) {
            // Shva Na - make just the nikud (dots) larger and bolder, same color as text
            return (
              <span
                key={segIdx}
                style={{
                  fontWeight: 1000,
                  fontSize: '1.5em',
                  position: 'relative',
                  right: '-0.06em',
                  lineHeight: 0, // Prevent affecting line spacing
                  verticalAlign: 'baseline',
                }}
                title="שְׁוָא נָע (Shva Na - pronounced)"
              >
                {segment.text}
              </span>
            );
          }
          return <span key={segIdx}>{segment.text}</span>;
        })}
        {wordIdx < words.length - 1 ? ' ' : ''}
      </React.Fragment>
    );
  });
};
